var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("SelectPicker", {
    staticClass: "sort",
    attrs: {
      "data-class": "btn-sm btn-default",
      placeholder: _vm.$t("results.sort.sortBy"),
      "data-menu-width": "grow",
      allowHtml: "",
      hideDisabled: "",
      allowUnknownValues: "",
      right: "",
      searchable: _vm.sortOptions.searchable,
      options: _vm.sortOptions.options,
      disabled: _vm.disabled,
    },
    model: {
      value: _vm.model,
      callback: function ($$v) {
        _vm.model = $$v
      },
      expression: "model",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }